import http from './_http';

const baseUrlOnboarding = '/onboarding';
const url = `${http.baseUrl}${baseUrlOnboarding}`;

// TODO: investigate usage and remove this. Most likely dead code
export async function onboardingDefaultsSet({ companyId, documents }) {
  if (!(documents instanceof Array)) {
    throw new Error('documents should be an array.');
  }

  for (const document of documents) {
    if (!document || !document.documentName) {
      throw new Error('document.documentName is required.');
    }

    if (!document.fields || !(document.fields instanceof Array)) {
      throw new Error('document.fields should be an array.');
    } else {
      for (const field of document.fields) {
        if (!field.name || !field.type) {
          throw new Error('field.name and field.type are required.');
        }
      }
    }
  }

  try {
    const result = await http.post(
      `${baseUrlOnboarding}/settings/tenants/${companyId}`,
      {
        companyId: companyId.toString(),
        documents,
      }
    );

    if (!result || !result.data || !result.data.data) {
      return {};
    }

    return result.data.data;
  } catch (e) {
    console.error(e);

    if (e && e.response && e.response.data) {
      throw new Error(e.response.data);
    }

    throw new Error(e);
  }
}

// TODO: investigate usage and remove this. Most likely dead code
export async function onboardingDefaultsGet(companyId) {
  try {
    const result = await http.get(
      `${baseUrlOnboarding}/settings/tenants/${companyId}`
    );

    if (!result || !result.data || !result.data.data) {
      return {};
    }

    return result.data.data;
  } catch (e) {
    console.error(e);

    return {}; // TODO: remove this after fixing the backend svc

    // if (e && e.response && e.response.error && e.response.error.message) {
    //   throw new Error(e.response.error.message);
    // }
    //
    // throw new Error(e);
  }
}

export function get(id) {
  if (process.env.MOCK) {
    // TODO: implement this pathway
    // if (process.env.MOCK_DOCUMENTS.success === false) {
    // }

    return Promise.resolve().then(() => process.env.MOCK_ONBOARDING.data);
  }

  return http
    .get(`${baseUrlOnboarding}/${id}`)
    .then(({ data }) => data.data)
    .catch((e = {}) => {
      console.error(e);

      if (e.response && e.response.data) {
        throw e.response.data.error;
      }

      throw e.response;
    });
}

export function create(data) {
  return http
    .post(`${baseUrlOnboarding}`, data)
    .then(({ data }) => data.data)
    .catch((e = {}) => {
      console.error(e);

      if (e.response && e.response.data) {
        throw e.response.data.error;
      }

      throw e.response;
    });
}

// export function sendNewLink(session) {
//   return http
//     .post(`${baseUrlOnboarding}/${id}/resend`, { session })
//     .then(({ data }) => data.data)
//     .catch((e = {}) => {
//       console.error(e);
//
//       if (e.response && e.response.data) {
//         throw e.response.data.error;
//       }
//
//       throw e.response;
//     });
// }

export function status(id, state) {
  if (!id) {
    throw new Error('Onboarding Id is required.');
  }

  if (!state) {
    return http.get(`${baseUrlOnboarding}/${id}/status`).then(({ data }) => {
      if (!data || !data.data) {
        return {
          completion: 0,
        };
      }

      return data.data;
    });
  }

  return http
    .post(`${baseUrlOnboarding}/${id}/status`, { state })
    .then(({ data }) => {
      if (!data || !data.data) {
        return {
          completion: 0,
        };
      }

      return data.data;
    });
}

export function submit(id) {
  if (!id) {
    throw new Error('Onboarding Id is required.');
  }

  return http
    .post(`${baseUrlOnboarding}/${id}/status`, { state: 'SUBMITTED' })
    .then(() => true);
}

// TODO: investigate usage and remove this. Most likely dead code
export function defaults({ companyId, documents }) {
  if (!companyId) {
    throw new Error('companyId is required.');
  }

  if (!documents) {
    return onboardingDefaultsGet(companyId);
  }

  return onboardingDefaultsSet({ companyId, documents });
}

export default {
  url,
  create,
  get,
  // sendNewLink,
  status,
  submit,
  defaults,
};
